import React from "react"
import RyderLivescoringTeam from "@/components/RyderLivescoring/RyderLivescoringTeam"
import RyderLivescoringHoles from "@/components/RyderLivescoring/RyderLivescoringHoles"

const RyderLivescoringMatchCardNin9rsView = ({
    leftWon,
    rightWon,
    leftPlayers,
    leftIdNum,
    tbdLeft,
    leftSide,
    rightPlayers,
    rightIdNum,
    tbdRight,
    rightSide,
    match,
    isDraw,
    holes,
    teamColors,
    customDesign
}) => {
    return (
        <div className="relative mb-2 overflow-hidden border-0">
            <div className="flex flex-col sm:flex-row justify-center w-full">
                <RyderLivescoringTeam
                    players={leftPlayers}
                    teamColor={teamColors[leftIdNum]}
                    isWinner={leftWon}
                    isDraw={isDraw}
                    result={match.result}
                    match={match}
                    tbd={tbdLeft}
                    side={leftSide}
                    customDesign={customDesign}
                />
                <RyderLivescoringTeam
                    players={rightPlayers}
                    teamColor={teamColors[rightIdNum]}
                    isWinner={rightWon}
                    isDraw={isDraw}
                    result={match.result}
                    tbd={tbdRight}
                    match={match}
                    isRight={true}
                    side={rightSide}
                    customDesign={customDesign}
                />
            </div>

            <RyderLivescoringHoles
                holes={holes}
                team1Id={leftIdNum}
                team2Id={rightIdNum}
                teamColors={teamColors}
                match={match}
                customDesign={customDesign}
            />
        </div>
    )
}

export default RyderLivescoringMatchCardNin9rsView
